import React from "react";
import Link from "next/link";
import { withRouter } from "next/router";
import css from "../../static/css/topnavigation.css";
import jQ from "jquery";
import $ from "jquery";

class TopNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navClass: "navbar-default",
      toggleIcon: "fas fa-chevron-down",
      navId: ''
    };
    this.handleScroll = this.handleScroll.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    jQ(".navbar-collapse>.navbar-nav>li>a").on("click", function() {
      if (jQ(window).width() <= 768) {
        jQ(".navbar-toggler").click();
      }
    });
    jQ(".navbar-toggler").on("click", () => {
      const State = jQ(".navbar-collapse").hasClass("show");
      const Class = State ? "fas fa-chevron-down" : "fas fa-chevron-up";
      this.setState({ toggleIcon: Class });
    });
    window.$('[data-toggle="popover"]').popover();

    $("#myModal").on("shown.bs.modal", function() {
      $("#myInput").trigger("focus");
    });
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll() {
    var scroll = window.pageYOffset;
    const Navclass = scroll <= 50 ? "navbar-default" : "navbar-default-active";
    this.state.navClass !== Navclass
      ? this.setState({ navClass: Navclass })
      : "";
      const Navclasss = scroll <= 50 ? "navbar-default-active" : "navbar-default-active";
      this.state.navClass !== Navclass
        ? this.setState({ navClass: Navclass })
        : "";
  }
  setActive(path) {
    // this.setState({ navId: path },()=>{
    //   console.log(this.state.path)
    //   return path === this.props.router.pathname ? "active" : "";
    // });
    console.log(path)
    return path === this.props.router.pathname ? "active" : "";
  }

  render() {
    return (
      <div className={`container-fluid fixed-top ${this.state.navClass}`}>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <nav
                className="navbar navbar-expand-lg navbar-light"
                style={{ padding: "0px" }}
              >
                <a className="navbar-brand" href="/">
                  <img
                    src="/static/images/UPS_Logo.png"
                    alt="logo"
                    className="logo"
                  />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span
                    className={this.state.toggleIcon}
                    style={{ color: "white" }}
                  />
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                      <Link prefetch href="/" passHref>
                        <a className={`nav-link ${this.setActive("/")}`}>
                          HOME
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link prefetch href="/products-and-services" passHref>
                        <a
                          className={`nav-link ${this.setActive(
                            "/products-and-services"
                          )}`}
                        >
                          PRODUCTS & SERVICES
                        </a>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <a href="http://blog.unified.ph/" className="nav-link">BLOG</a>
                    </li> */}
                    <li className="nav-item">
                      <Link prefetch href="/about" passHref>
                        <a className={`nav-link ${this.setActive("/about")}`}>
                          ABOUT
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link prefetch href="/events" passHref>
                        <a className={`nav-link ${this.setActive("/events")}`}>
                          EVENTS
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link prefetch href="/contact" passHref>
                        <a className={`nav-link ${this.setActive("/contact")}`}>
                          CONTACT
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link prefetch href="/gallery" passHref>
                        <a className={`nav-link ${this.setActive("/gallery")}`}>
                          GALLERY
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link prefetch href="/kyc" passHref>
                        <a className={`nav-link kycs ${this.setActive("/kyc")}`}>
                          KYC
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link space" />
                    </li>
                    <li id="hiding" className="nav-item" style={{ paddingBottom: "13px" }}>
                      <a
                        className="btn login-button "
                        rel="noopener noreferrer"
                        style={{ textAlign: "center" }}
                        data-toggle="popover"
                        data-placement="bottom"
                        data-html="true"
                        data-content="<a href='https://secure.unified.ph' style={{color:'#ffffff'}} id='popoverLink' target='_blank'>Legacy Account</a>
                         <hr/> <a id='popoverLink'style={{color:'#ffffff'}} target='_blank' href='https://online.unified.ph/' >Version 3</a>"
                      >
                        Login
                      </a>
                      {/* <a href="#" className="btn login-button popover" data-toggle="popover" data-placement="bottom"  data-html="true" data-content="<a href='https://secure.unified.ph' className='nav-link' target='_blank'>Legacy Account</a><br/><hr/><a className='nav-link' href='https://beta.unified.ph/' >V3</a>">Toggle popover</a>  */}
                    </li>

                    <li id="showing" className="nav-item" style={{ paddingBottom: "13px" }}>
                      <a
                        className="btn login-button "
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                      >
                        Login
                      </a>
                      {/* <a href="#" className="btn login-button popover" data-toggle="popover" data-placement="bottom"  data-html="true" data-content="<a href='https://secure.unified.ph' className='nav-link' target='_blank'>Legacy Account</a><br/><hr/><a className='nav-link' href='https://beta.unified.ph/' >V3</a>">Toggle popover</a>  */}
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="exampleModalCenter"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <a
                  href="https://secure.unified.ph"
                  id="popoverLink"
                  target="_blank"
                >
                  Legacy Account
                </a>
                <hr />{" "}
                <a
                  id="popoverLink"
                  target="_blank"
                  href="https://online.unified.ph"
                >
                  Version 3
                </a>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
            #popoverLink{
              color:#000000 !important;
              text-align:center;
              font-size:12px;
              padding-right: 8px;
              padding-left: 8px;
            }
            #popoverLink:hover{
              text-decoration: none
            }
            hr {
              display: block;
              unicode-bidi: isolate;
              margin-block-start: 0.5em;
              margin-block-end: 0.5em;
              margin-inline-start: auto;
              margin-inline-end: auto;
            }
            .modal-backdrop{
              display:none
            }
            #showing{
              display:none !important;
            }
            @media only screen and (max-width: 700px) {
            #hiding{
              display:none !important;
            }
            #showing{
              display:block !important;
            }
            .modal{
              width:90% !important;
              text-align: center !important;
              padding-left:10%
            }
            .modal-dialog .modal-dialog-centered{
              width:100% !important;
            }
            .modal .fade .show{
              width:100% !important;
            }
            #popoverLink{
              color:#000000 !important;
              text-align:center;
              font-size:15px;
              padding-right: 8px;
              padding-left: 8px;
            }
            #popoverLink:hover{
              text-decoration: none
            }
            .popover-body{
              display:none !important;
            }
            .arrow{
              display:none !important;
            }
          }`}
        </style>
      </div>
    );
  }
}

export default withRouter(TopNavigation);



// WEBPACK FOOTER //
// components/template/TopNavigation.js